function openShareWindow({
  url,
  title,
  w,
  h,
}: {
  url: string;
  title: string;
  w: number;
  h: number;
}) {
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;

  return window.open(
    url,
    title,
    `${
      'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, ' +
      'copyhistory=no, width='
    }${w}, height=${h}, top=${top}, left=${left}`,
  );
}

export type SocialPlatform = 'linkedin' | 'twitter' | 'facebook';

export interface ShareToSocialArgs {
  platform: SocialPlatform;
  title?: string;
  description?: string;
  url: string;
}

export const shareToSocial = ({ platform, title, description, url }: ShareToSocialArgs): void => {
  const shareTitle = encodeURIComponent(title || '');
  const shareText = encodeURIComponent(description || '');
  let platformUrl;
  const windowWidth = 500;
  let windowHeight = 550;

  switch (platform) {
    case 'linkedin':
      platformUrl = `http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${shareTitle}&summary=${shareText}&source=${shareTitle}`;
      break;
    case 'twitter':
      platformUrl = `http://twitter.com/share?url=${url}&text=${shareText}`;
      windowHeight = 300;
      break;
    case 'facebook':
      platformUrl = `http://www.facebook.com/sharer.php?u=${url}`;
      break;
    default:
      throw new Error(`Unknown media: ${platform}`);
  }
  openShareWindow({ url: platformUrl, title: 'hjShareWindow', w: windowWidth, h: windowHeight });
};
